import axios from 'axios';
import { baseURL } from '../helpers/constants';

export async function getAllProjects(params) {
  const endPoint = '/projects';
  const url = baseURL + endPoint;

  const res = await axios.get(url, { params });
  return res.data;
}

export async function getProjectDetails(id, params) {
  const endPoint = `/projects/${id}/localized`;
  const url = baseURL + endPoint;

  const res = await axios.get(url, { params });
  return res.data.data;
}
export async function createProject(object) {
  const endPoint = `/projects`;
  const url = baseURL + endPoint;

  const res = await axios.post(url, object);
  return res.data;
}

export async function deleteProject(id) {
  const endPoint = `/projects/${id}`;
  const url = baseURL + endPoint;

  const res = await axios.delete(url);
  return res.data;
}
